/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-footer/plantlife-cheap-weed-footer/plantlife-cheap-weed-empty-footer/plantlife-cheap-weed-empty-footer.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.print-menu.plantlife-cheap-weed-theme {
  page: plantlife-cheap-weed-theme-pages;
}
@page plantlife-cheap-weed-theme-pages {
  margin: 0.25in;
}
.plantlife-cheap-weed-theme {
  --badge-grid-min-col: 1.1rem;
}
.plantlife-cheap-weed-theme .header-container-wrapper {
  color: #98cc5c;
}
.plantlife-cheap-weed-theme .header-container {
  flex-direction: row;
  justify-content: space-between;
  min-height: 1rem;
  padding-left: 0.7272727273rem;
  padding-right: 0.7272727273rem;
  padding-bottom: 0;
  height: 6.8181818182rem;
}
.plantlife-cheap-weed-theme .header-container .company-logo {
  height: unset;
  max-width: 12.72rem;
  align-self: flex-end;
  margin-bottom: 0.9090909091rem;
  margin-left: 0.7272727273rem;
}
.plantlife-cheap-weed-theme .main-header {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 4.1818181818rem;
  text-align: end;
  min-width: 1rem;
  margin-right: 0.3636363636rem;
}
.plantlife-cheap-weed-theme .section-header-bottom-border {
  border-bottom: 1px solid;
}
.plantlife-cheap-weed-theme .sections-container {
  border-top-width: 0;
  margin-left: 0;
  margin-right: 0;
  padding: 0;
}
.plantlife-cheap-weed-theme .section-container {
  margin-left: 0.7272727273rem;
  margin-right: 0.7272727273rem;
}
.plantlife-cheap-weed-theme .title-section {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 4.1rem;
  color: #98cc5c;
  height: 4.3636363636rem;
  box-sizing: border-box;
  padding: 0 1.0909090909rem 0.3636363636rem 1.0909090909rem;
}
.plantlife-cheap-weed-theme .section-header-container {
  background-color: #98cc5c;
  color: #ffffff;
  border-color: #222222;
  height: 2.2727272727rem;
}
.plantlife-cheap-weed-theme .section-title,
.plantlife-cheap-weed-theme .section-header-general {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.3636363636rem;
  letter-spacing: -0.15px;
  text-transform: uppercase;
  text-align: center;
  padding: 0.3rem;
  height: 2.3rem;
}
.plantlife-cheap-weed-theme .section-header-general {
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  box-sizing: border-box;
}
.plantlife-cheap-weed-theme .product-container {
  border-bottom: 1px solid #222222;
  height: 4.3636363636rem;
  box-sizing: border-box;
}
.plantlife-cheap-weed-theme .product-title-container.first-column {
  padding-left: 0.3rem;
}
.plantlife-cheap-weed-theme .product-title-flex-container {
  gap: 0.3rem;
}
.plantlife-cheap-weed-theme .product-title {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.6rem;
}
.plantlife-cheap-weed-theme .product-badge {
  gap: 0.3rem;
}
.plantlife-cheap-weed-theme .product-subtitle {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.4rem;
}
.plantlife-cheap-weed-theme .product-column-general {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.4rem;
}
.plantlife-cheap-weed-theme .footer-container {
  background: transparent;
  background-color: unset !important;
}
.plantlife-cheap-weed-theme .product-strain-type {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 0.76rem;
  padding-right: 0.76rem;
  width: fit-content;
  height: 2.1rem;
  color: #ffffff;
}
.plantlife-cheap-weed-theme .product-strain-type.i,
.plantlife-cheap-weed-theme .product-strain-type.indica {
  background-color: #7663e3;
  border: 1px solid #7663e3;
}
.plantlife-cheap-weed-theme .product-strain-type.s,
.plantlife-cheap-weed-theme .product-strain-type.sativa {
  background-color: #f0a005;
  border: 1px solid #f0a005;
}
.plantlife-cheap-weed-theme .product-strain-type.h,
.plantlife-cheap-weed-theme .product-strain-type.hybrid {
  background-color: #77d11f;
  border: 1px solid #77d11f;
}
.plantlife-cheap-weed-theme .product-strain-type.b,
.plantlife-cheap-weed-theme .product-strain-type.blend {
  background-color: #5690f0;
  border: 1px solid #5690f0;
}
.plantlife-cheap-weed-theme .product-strain-type.c,
.plantlife-cheap-weed-theme .product-strain-type.cbd {
  background-color: #b8b8b8;
  border: 1px solid #b8b8b8;
}
.plantlife-cheap-weed-theme .product-label {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.9rem;
  height: 1rem;
  border-radius: 0.2rem;
  letter-spacing: 0.01rem;
}
.plantlife-cheap-weed-theme .badge {
  height: 1.1rem;
}
.plantlife-cheap-weed-theme .badge-within-badge-column {
  height: 2.1818181818rem;
}
.plantlife-cheap-weed-theme .empty-container {
  background-color: #ffffff;
  margin-left: 0.7272727273rem;
  margin-right: 0.7272727273rem;
}
.plantlife-cheap-weed-theme .image-section {
  margin-top: 0;
}
.plantlife-cheap-weed-theme .force-bold-style * {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.plantlife-cheap-weed-empty-footer {
  height: 1rem;
}
/*# sourceMappingURL=plantlife-cheap-weed-empty-footer.component.css.map */
